import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		changePassShow: false,
		alertShow: false,
		databaseDialogShow:false,
		databaseLoginShow: false,
		databaseTempId: null,
		databaseTempName: null,
		alertText: '',
		deleteDialogShow: false,
		databaseYuanId: null,
		databaseYuanName: null,
		auditShow: false,
		leftMenuShow:true,
		pkgParmsToData:{}
	},
	mutations: {
		CHANGE_PKGPARMS_TO_DATA (state, val) {
			state.pkgParmsToData = val;
		},
		CHANGE_AUDIT_SHOW (state, val) {
			state.auditShow = val;
		},
		CHANGE_DATABASE_YUAN_ID (state, val) {
			state.databaseYuanId = val;
		},
		CHANGE_DATABASE_YUAN_NAME (state, val) {
			state.databaseYuanName = val;
		},
		CHANGE_DELETE_DIALOG_SHOW (state, val) {
			state.deleteDialogShow = val;
		},
		CHANGE_ALERT_TEXT (state, val) {
			state.alertText = val;
		},
		CHANGE_DATABASE_TEMP_NAME (state, val) {
			state.databaseTempName = val;
		},
		CHANGE_DATABASE_TEMP_ID (state, val) {
			state.databaseTempId = val;
		},
		CHANGE_DATABASE_LOGIN_SHOW (state, val) {
			state.databaseLoginShow = val;
		},
		CHANGE_PASS_SHOW (state, val) {
			state.changePassShow = val;
		},
		CHANGE_ALERT_SHOW (state, val) {
			state.alertShow = val;
		},
		CHANGE_DATABASE_SHOW (state, val) {
			state.databaseDialogShow = val;
		},
		CHANGE_MENU_SHOW (state, val) {
			state.leftMenuShow = val;
		}
	}
});